import * as v from "valibot";
import { BaseRecordSchema, baseVals, defineValidation } from "../../common/validation.common";
import { DisbursementBankCodeEnum } from "../../data/enums";

export namespace FinanceDisbursementAccountValidation {
    export const Record = defineValidation(BaseRecordSchema);

    export const TransactionRecord = defineValidation(BaseRecordSchema);

    export const Create = defineValidation(
        v.object({
            name: baseVals.string(),
            bankCode: v.picklist(DisbursementBankCodeEnum.values),
            accountNumber: baseVals.string(),
            accountHolder: baseVals.string(),
            notes: v.optional(baseVals.string()),
        }),
    );

    export const Update = defineValidation(
        v.object({
            name: v.exactOptional(baseVals.string()),
            notes: v.exactOptional(baseVals.string()),
        }),
    );
}
